import createProperty from './create-property';

const RE_ISO_DATE = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/g;

export default createProperty({
  default: null,
  validate(v) {
    return typeof v === 'string' && v.match(RE_ISO_DATE);
  },
});
